enum PaymentStatus {
	NoPayment,
	ReadyToPay,
	ToVerify,
	Paid,
	Rejected,
	AwaitingConfirmation,
	Void
}

export default PaymentStatus;
